import {
  GlobalSearchReducerActionType,
  GlobalSearchReducerActions
} from './interfaces';

const getEntityData = (dispatch: Function) => (entity: string) => {
  const action = {
    type: GlobalSearchReducerActionType.GET_ENTITY_DATA,
    entity
  };

  dispatch(action);
};

const updateEntityData = (dispatch: Function) => (entity: string, data: object) => {
  const action = {
    type: GlobalSearchReducerActionType.UPDATE_ENTITY_DATA,
    entity,
    data
  };

  dispatch(action);
};

const bulkUpdateState = (dispatch: Function) => (data: object) => {
  const action = {
    data,
    type: GlobalSearchReducerActionType.BULK_UPDATE
  };

  dispatch(action);
};

const filterData = (dispatch: Function) => (filters: object) => {
  const action = {
    data: filters,
    type: GlobalSearchReducerActionType.FILTER_DATA
  };

  dispatch(action);
};

export function GlobalSearchReducerActionsFactory(dispatch: Function): GlobalSearchReducerActions {
  return {
    getEntityData: getEntityData(dispatch),
    updateEntityData: updateEntityData(dispatch),
    bulkUpdateState: bulkUpdateState(dispatch),
    filterData: filterData(dispatch)
  };
}
